import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'OptionenPipe',
    standalone: false
})
export class OptionenPipe implements PipeTransform {


   transform(array:Array<any>, tarifID: string, opt: string[]): Array<any> 
   {
 		
 		console.log("array ->" +array.length + " / " + opt + " / " +array);
 		
 		var optionen = [];
	 		
	 		let i=0;
	 		while (i < array.length) 
	 		{
	 			//optionen.push(array[i]);
	 			
		 		if (array[i].OptionID=="Eco" && (tarifID=='Todesfall' ||tarifID=='Prophylaxe'))
		 		{
		 			//nix
		 		}else if (array[i].OptionID=="Standard" && (tarifID=='Todesfall' ||tarifID=='Prophylaxe'))
		 		{		 	
		 			//nix		 
		 		}else if (array[i].OptionID=="Premium" && (tarifID=='Todesfall' ||tarifID=='Prophylaxe'))
		 		{		 	
		 			//nix
		 		}else if (array[i].OptionID=="Helikoptertransport" && opt.includes("Eco"))
		 		{
		 		//nix
		 		}else
		 		{
		 			optionen.push(array[i]);
		 		}
		 		i++;
		 	} 
		 
 		
	
    return optionen;
  }

}
